export { default } from './BillingAccount.container'



// WEBPACK FOOTER //
// ./src/pages/BillingAccount/index.js